<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Certificado de Título",
            cargandoOpciones: false,
            cargandoContactos: false,
            errorOpciones: '',
            errorContactos: '',
            errorPdf: '',
            cargandoPdf: false,
            validandoCertificado: false,
            sincronizado: null,
            sincronizandoFondo: false,
            sincronizandoTodo: false,
            contactosRequestToken: 0,
            carrerasAdvance: [],
            contactosCarrera: [],
            periodoFijo: '',
            modalCertificadoVisible: false,
            certificadoSeleccionado: null,
            contactoSeleccionado: null,
            filtros: {
                carrera: ''
            },
            items: [
                {
                    text: "Configuración",
                    href: "/"
                },
                {
                    text: "Certificado de Título",
                    active: true
                }
            ]
        };
    },
    mounted() {
        this.cargarOpcionesHubSpot();
    },
    watch: {
        'filtros.carrera'() {
            this.cargarContactosCarrera();
        }
    },
    methods: {
        async cargarOpcionesHubSpot() {
            this.cargandoOpciones = true;
            this.errorOpciones = '';

            try {
                const { data } = await axios.get('/api/certificado_titulo/opciones');
                this.carrerasAdvance = Array.isArray(data.carreras_advance) ? data.carreras_advance : [];
                this.periodoFijo = data.periodo_fijo || '';
            } catch (error) {
                this.errorOpciones = error?.response?.data?.message || 'No se pudieron cargar las opciones desde HubSpot.';
            } finally {
                this.cargandoOpciones = false;
            }
        },
        async cargarContactosCarrera(forzar = false) {
            const carreraSeleccionada = this.filtros.carrera;
            const requestToken = ++this.contactosRequestToken;

            this.contactosCarrera = [];
            this.errorContactos = '';
            this.sincronizado = null;
            this.sincronizandoFondo = false;
            this.cerrarModalCertificado();

            if (!carreraSeleccionada) {
                return;
            }

            this.cargandoContactos = true;

            try {
                if (forzar) {
                    const { data } = await axios.get('/api/certificado_titulo/contactos', {
                        params: { carrera: carreraSeleccionada, sync: true }
                    });

                    if (requestToken !== this.contactosRequestToken || carreraSeleccionada !== this.filtros.carrera) {
                        return;
                    }

                    this.contactosCarrera = Array.isArray(data.contactos) ? data.contactos : [];
                    this.sincronizado = data.sincronizado ?? null;
                    return;
                }

                const { data } = await axios.get('/api/certificado_titulo/contactos', {
                    params: { carrera: carreraSeleccionada, cache_first: true }
                });

                if (requestToken !== this.contactosRequestToken || carreraSeleccionada !== this.filtros.carrera) {
                    return;
                }

                this.contactosCarrera = Array.isArray(data.contactos) ? data.contactos : [];
                this.sincronizado = data.sincronizado ?? null;

                if (data.background_sync_suggested) {
                    this.sincronizandoFondo = true;
                    this.ejecutarSyncEnSegundoPlano(carreraSeleccionada, requestToken);
                }
            } catch (error) {
                if (requestToken === this.contactosRequestToken && carreraSeleccionada === this.filtros.carrera) {
                    this.errorContactos = error?.response?.data?.message || 'No se pudieron cargar los contactos de la carrera.';
                }
            } finally {
                if (requestToken === this.contactosRequestToken && carreraSeleccionada === this.filtros.carrera) {
                    this.cargandoContactos = false;
                }
            }
        },
        async ejecutarSyncEnSegundoPlano(carrera, requestToken) {
            try {
                const { data } = await axios.get('/api/certificado_titulo/contactos', {
                    params: { carrera, sync: true }
                });

                if (requestToken !== this.contactosRequestToken || carrera !== this.filtros.carrera) {
                    return;
                }

                this.contactosCarrera = Array.isArray(data.contactos) ? data.contactos : [];
                this.sincronizado = data.sincronizado ?? null;
            } catch (error) {
                if (requestToken === this.contactosRequestToken && carrera === this.filtros.carrera && !this.contactosCarrera.length) {
                    this.errorContactos = error?.response?.data?.message || 'No se pudieron sincronizar los contactos desde HubSpot.';
                }
            } finally {
                if (requestToken === this.contactosRequestToken && carrera === this.filtros.carrera) {
                    this.sincronizandoFondo = false;
                }
            }
        },
        async forzarSync() {
            await this.cargarContactosCarrera(true);
        },
        async sincronizarTodo() {
            this.sincronizandoTodo = true;
            try {
                await axios.post('/api/certificado_titulo/limpiar_sync');
                if (this.filtros.carrera) {
                    await this.cargarContactosCarrera(true);
                }
            } catch (e) {
                // silencioso
            } finally {
                this.sincronizandoTodo = false;
            }
        },
        abrirModalCertificado(contacto) {
            if (!contacto || !contacto.certificado || !contacto.certificado.preview_url) {
                return;
            }

            this.certificadoSeleccionado = {
                nombreContacto: contacto.nombre || 'Sin nombre',
                nombreArchivo: contacto.certificado.nombre || 'Certificado',
                tipo: '',
                extension: (contacto.certificado.extension || '').toLowerCase(),
                url: contacto.certificado.preview_url,
                expiraEn: contacto.certificado.expira_en || ''
            };
            this.errorPdf = '';
            this.cargandoPdf = false;
            this.contactoSeleccionado = contacto;
            this.modalCertificadoVisible = true;

            if (this.esPdfCertificado(this.certificadoSeleccionado)) {
                this.cargarYRenderizarPdf(this.certificadoSeleccionado.url);
            }
        },
        cerrarModalCertificado() {
            this.modalCertificadoVisible = false;
            this.certificadoSeleccionado = null;
            this.contactoSeleccionado = null;
            this.errorPdf = '';
            this.cargandoPdf = false;
            const container = this.$refs.pdfCanvasContainer;
            if (container) {
                container.innerHTML = '';
            }
        },
        async cargarYRenderizarPdf(url) {
            this.cargandoPdf = true;
            this.errorPdf = '';
            const container = this.$refs.pdfCanvasContainer;
            if (container) {
                container.innerHTML = '';
            }

            // Esperar a que Vue renderice el contenedor en el DOM
            await this.$nextTick();

            try {
                if (!window.pdfjsLib) {
                    this.errorPdf = 'El visor de PDF no está disponible.';
                    return;
                }

                window.pdfjsLib.GlobalWorkerOptions.workerSrc =
                    'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.14.305/pdf.worker.min.js';

                const response = await axios.get(url, { responseType: 'arraybuffer' });
                const pdfData = new Uint8Array(response.data);
                const pdfDoc = await window.pdfjsLib.getDocument({ data: pdfData }).promise;

                const cnt = this.$refs.pdfCanvasContainer;
                if (!cnt) {
                    this.errorPdf = 'El contenedor del visor no está disponible.';
                    return;
                }

                cnt.innerHTML = '';

                for (let pageNum = 1; pageNum <= pdfDoc.numPages; pageNum++) {
                    const page = await pdfDoc.getPage(pageNum);
                    const viewport = page.getViewport({ scale: 1.4 });
                    const canvas = document.createElement('canvas');
                    canvas.width = viewport.width;
                    canvas.height = viewport.height;
                    canvas.style.cssText = 'max-width:100%;height:auto;display:block;margin-bottom:12px;border-radius:8px;border:1px solid #E4E9F2;';
                    cnt.appendChild(canvas);
                    await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise;
                }
            } catch (e) {
                this.errorPdf = 'No se pudo cargar el PDF.';
            } finally {
                this.cargandoPdf = false;
            }
        },
        esImagenCertificado(certificado) {
            if (!certificado) {
                return false;
            }

            const tipo = (certificado.tipo || '').toUpperCase();
            const extension = (certificado.extension || '').toLowerCase();
            return tipo === 'IMG' || ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension);
        },
        esPdfCertificado(certificado) {
            if (!certificado) {
                return false;
            }

            return (certificado.extension || '').toLowerCase() === 'pdf';
        },
        puedePrevisualizarCertificado(certificado) {
            return this.esImagenCertificado(certificado) || this.esPdfCertificado(certificado);
        },
        getCertificadoPreviewUrl(certificado) {
            if (!certificado || !certificado.url) {
                return '';
            }

            return certificado.url;
        },
        async validarCertificado() {
            const contacto = this.contactoSeleccionado;
            if (!contacto || !contacto.local_id) {
                return;
            }

            this.validandoCertificado = true;
            try {
                const { data } = await axios.post(
                    `/api/certificado_titulo/contactos/${contacto.local_id}/validar`
                );

                // Actualizar reactivamente en la tabla
                const idx = this.contactosCarrera.findIndex(c => c.local_id === contacto.local_id);
                if (idx !== -1) {
                    this.$set(this.contactosCarrera, idx, {
                        ...this.contactosCarrera[idx],
                        validado: data.validado,
                        validado_at: data.validado_at,
                        validado_por: data.validado_por,
                    });
                    // Sincronizar el contacto seleccionado
                    this.contactoSeleccionado = this.contactosCarrera[idx];
                }
            } catch (e) {
                // Error silencioso: no interrumpir el modal
            } finally {
                this.validandoCertificado = false;
            }
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row">
            <div class="col-12">
                <div class="card shadow-sm border-0">
                    <div class="card-header py-3 d-flex align-items-center"
                        style="background: linear-gradient(135deg, #252C5F 0%, #61B7E4 100%); border-radius: 4px 4px 0 0;">
                        <i class="bx bx-award font-size-24 text-white mr-2"></i>
                        <div>
                            <h5 class="text-white mb-0 font-weight-bold">Certificado de Título</h5>
                            <small class="text-white" style="opacity:.8;">Vista exclusiva para administradores</small>
                        </div>
                    </div>

                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-8">
                                <div class="d-flex justify-content-between align-items-center mb-3">
                                    <h4 class="mb-0" style="color:#252C5F;">Pipeline Advance 2026-2</h4>
                                    <button
                                        type="button"
                                        class="btn btn-sm btn-outline-primary"
                                        :disabled="sincronizandoTodo || cargandoContactos || sincronizandoFondo"
                                        @click="sincronizarTodo"
                                        title="Limpiar caché y forzar sincronización completa con HubSpot"
                                    >
                                        <i class="bx" :class="sincronizandoTodo ? 'bx-loader-alt bx-spin' : 'bx-refresh'"></i>
                                        {{ sincronizandoTodo ? 'Sincronizando...' : 'Sincronizar todo' }}
                                    </button>
                                </div>

                                <div class="row">
                                    <div class="col-md-8 mb-3">
                                        <label class="font-weight-bold text-dark">Carrera Advance</label>
                                        <select class="form-control" v-model="filtros.carrera" :disabled="cargandoOpciones || !carrerasAdvance.length">
                                            <option value="">Selecciona una carrera</option>
                                            <option v-for="option in carrerasAdvance" :key="option.value" :value="option.value">
                                                {{ option.label }}
                                            </option>
                                        </select>
                                        <small class="text-muted d-block mt-2">
                                            {{ cargandoOpciones ? 'Cargando carreras desde HubSpot...' : `${carrerasAdvance.length} carreras disponibles` }}
                                        </small>
                                    </div>

                                    <div class="col-md-4 mb-3">
                                        <label class="font-weight-bold text-dark">Periodo</label>
                                        <input class="form-control" :value="periodoFijo || '2026 - 2'" disabled>
                                    </div>
                                </div>

                                <div v-if="errorOpciones" class="alert alert-danger mb-0">
                                    {{ errorOpciones }}
                                </div>

                                <div class="mt-4">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <div>
                                            <h5 class="mb-0" style="color:#252C5F;">Contactos de la carrera</h5>
                                            <small v-if="sincronizado === true" class="text-success">
                                                <i class="bx bx-refresh"></i> Sincronizado con HubSpot
                                            </small>
                                            <small v-else-if="sincronizandoFondo" class="text-info">
                                                <i class="bx bx-loader-alt bx-spin"></i> Mostrando caché local mientras sincronizamos con HubSpot
                                            </small>
                                            <small v-else-if="sincronizado === false" class="text-muted">
                                                <i class="bx bx-data"></i> Desde caché local &mdash; sin cambios en HubSpot
                                            </small>
                                        </div>
                                        <small class="text-muted">
                                            {{ cargandoContactos ? 'Cargando caché...' : (sincronizandoFondo ? 'Sincronizando...' : `${contactosCarrera.length} contactos`) }}
                                        </small>
                                    </div>

                                    <div v-if="filtros.carrera && !cargandoContactos" class="alert alert-light border d-flex justify-content-between align-items-center">
                                        <span>
                                            Contactos en <strong>{{ filtros.carrera }}</strong>
                                        </span>
                                        <strong style="color:#252C5F;">{{ contactosCarrera.length }}</strong>
                                    </div>

                                    <div v-if="errorContactos" class="alert alert-danger">
                                        {{ errorContactos }}
                                    </div>

                                    <div v-else-if="!filtros.carrera" class="alert alert-light border">
                                        Selecciona una carrera para ver los contactos asociados.
                                    </div>

                                    <div v-else-if="cargandoContactos" class="alert alert-info mb-0">
                                        Cargando datos locales...
                                    </div>

                                    <div v-else-if="!contactosCarrera.length" class="alert alert-warning mb-0">
                                        No se encontraron contactos para esta carrera en el período {{ periodoFijo || '2026 - 2' }}.
                                    </div>

                                    <div v-else-if="sincronizandoFondo" class="alert alert-info mb-3">
                                        Mostrando datos locales. Sincronizando con HubSpot en segundo plano...
                                    </div>

                                    <div v-if="!cargandoContactos && filtros.carrera && contactosCarrera.length" class="table-responsive">
                                        <table class="table table-sm table-hover mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Etapa</th>
                                                    <th>Nombre</th>
                                                    <th>Email</th>
                                                    <th>Teléfono</th>
                                                    <th>RUT</th>
                                                    <th>Certificado</th>
                                                    <th>Estado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="contacto in contactosCarrera" :key="`${contacto.negocio_id}-${contacto.id}`">
                                                    <td>
                                                        <span class="badge badge-soft-info font-size-12">{{ contacto.negocio_etapa || '-' }}</span>
                                                    </td>
                                                    <td>{{ contacto.nombre || '-' }}</td>
                                                    <td>{{ contacto.email || '-' }}</td>
                                                    <td>{{ contacto.telefono || '-' }}</td>
                                                    <td>{{ contacto.rut || '-' }}</td>
                                                    <td>
                                                        <div v-if="contacto.tiene_certificado && contacto.certificado">
                                                            <button
                                                                type="button"
                                                                @click="abrirModalCertificado(contacto)"
                                                                class="btn btn-sm btn-outline-primary"
                                                            >
                                                                Ver
                                                            </button>
                                                        </div>
                                                        <span v-else class="badge badge-soft-secondary font-size-12">Sin certificado</span>
                                                    </td>
                                                    <td class="text-center">
                                                        <span
                                                            v-if="contacto.validado"
                                                            class="badge badge-soft-success font-size-13"
                                                            :title="`Validado por ${contacto.validado_por || 'Admin'}`"
                                                        >
                                                            <i class="bx bx-check-circle"></i> Válido
                                                        </span>
                                                        <span
                                                            v-else
                                                            class="badge badge-soft-secondary font-size-13"
                                                            title="Sin validar"
                                                        >
                                                            <i class="bx bx-x-circle"></i> Sin validar
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 mt-4 mt-lg-0">
                                <div class="p-4 h-100" style="background:#F6F8FC;border:1px solid #E4E9F2;border-radius:12px;">
                                    <div class="d-flex align-items-center mb-3">
                                        <div class="mr-3 d-flex align-items-center justify-content-center"
                                            style="width:44px;height:44px;border-radius:12px;background:#252C5F;">
                                            <i class="bx bx-shield-quarter text-white font-size-20"></i>
                                        </div>
                                        <div>
                                            <div class="font-weight-bold" style="color:#252C5F;">Acceso restringido</div>
                                            <small class="text-muted">Solo Admin y SuperAdmin</small>
                                        </div>
                                    </div>

                                    <ul class="mb-0 pl-3 text-muted">
                                        <li>Carreras obtenidas desde la etapa Matriculado del pipeline Advance.</li>
                                        <li>Período fijo aplicado: 2026 - 2.</li>
                                        <li>Endpoint protegido para Admin y SuperAdmin.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="modalCertificadoVisible" class="certificado-modal-backdrop" @click.self="cerrarModalCertificado">
            <div class="certificado-modal card shadow-lg border-0">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <div>
                        <h5 class="mb-0" style="color:#252C5F;">{{ certificadoSeleccionado?.nombreContacto || 'Certificado' }}</h5>
                        <small class="text-muted">{{ certificadoSeleccionado?.nombreArchivo || '' }}</small>
                    </div>
                    <button type="button" class="close" aria-label="Cerrar" @click="cerrarModalCertificado">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="card-body certificado-modal-body">
                    <img
                        v-if="esImagenCertificado(certificadoSeleccionado)"
                        :src="getCertificadoPreviewUrl(certificadoSeleccionado)"
                        :alt="certificadoSeleccionado.nombreArchivo"
                        class="img-fluid rounded border"
                    >

                    <div v-else-if="esPdfCertificado(certificadoSeleccionado)" class="w-100">
                        <div v-if="errorPdf" class="alert alert-warning mb-0 text-left">
                            {{ errorPdf }}
                        </div>

                        <div v-else-if="cargandoPdf" class="alert alert-info mb-0 text-left">
                            Cargando PDF...
                        </div>

                        <!-- v-show (no v-if) para que el ref esté siempre en el DOM mientras renderiza -->
                        <div
                            ref="pdfCanvasContainer"
                            v-show="!cargandoPdf && !errorPdf"
                            class="pdf-canvas-container"
                        ></div>
                    </div>

                    <div v-else class="alert alert-warning mb-0 text-left">
                        Este archivo no se puede previsualizar dentro de la plataforma.
                        <br>
                        Formato detectado: <strong>{{ certificadoSeleccionado?.extension || certificadoSeleccionado?.tipo || 'desconocido' }}</strong>.
                    </div>
                </div>

                <div class="card-footer d-flex justify-content-between align-items-center">
                    <small class="text-muted">{{ certificadoSeleccionado?.expiraEn ? `Enlace válido hasta ${certificadoSeleccionado.expiraEn}` : '' }}</small>
                    <button
                        v-if="contactoSeleccionado"
                        type="button"
                        class="btn btn-sm"
                        :class="contactoSeleccionado.validado ? 'btn-outline-danger' : 'btn-success'"
                        :disabled="validandoCertificado"
                        @click="validarCertificado"
                    >
                        <i class="bx" :class="contactoSeleccionado.validado ? 'bx-x-circle' : 'bx-check-circle'"></i>
                        {{ validandoCertificado ? 'Guardando...' : (contactoSeleccionado.validado ? 'Quitar validación' : 'Marcar como válido') }}
                    </button>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
.certificado-modal-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(16, 24, 40, 0.68);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    z-index: 1050;
}

.certificado-modal {
    width: min(1100px, 100%);
    max-height: calc(100vh - 48px);
    overflow: hidden;
    border-radius: 16px;
}

.certificado-modal-body {
    background: #F8FAFC;
    overflow: auto;
    max-height: calc(100vh - 220px);
    text-align: center;
}

.pdf-preview-stack {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
}

.pdf-canvas-container {
    width: 100%;
    padding: 8px 0;
}
</style>
